module.exports = __webpack_public_path__ + "static/media/react-icon.47ce6e77.png";